import Flex from 'components/ui/Flex';
import { styled } from 'styled-components';

type SideBarProps = {
    children: React.ReactNode; // Content to render inside the sidebar
};

const SideBar = ({ children }: SideBarProps) => {
    return (
        <Wrapper column className="sidebar-wrapper">
            <Content column $grow={1} gap="1rem" className="sidebar-content">
                {children}
            </Content>
        </Wrapper>
    );
};

export default SideBar;

const Wrapper = styled(Flex)`
    /* position: relative; */
    /* width: 100%; */
    /* max-width: 100%; */
    /* position: sticky; */
`;
const Content = styled(Flex)`
    /* position: sticky; */
`;
